/**
 * Converts the nodeset into a format readable for the GQL endpoint.
 */
import * as _ from 'lodash';

import { BlacklistNode, BlacklistDirective } from '../components/Inputs/Blacklist';
export interface BlacklistUnless {
    unless: string[];
    block: string[];
}

export interface BlacklistPayload {
    combined?: string[][];
    unless?: BlacklistUnless[];
    block?: string[];
}

/**
 * Transforms an instruction set of 
 * `unless <tag> block <tag>` 
 * into the gql JSON set.
 * 
 * @param {BlacklistNode[]} nodes 
 * @returns {BlacklistUnless} 
 */
function parseUnlessSet(nodes: BlacklistNode[]): BlacklistUnless {
    const unlessPosition = nodes.indexOf(
        nodes.filter(n => n.directive === BlacklistDirective.BLOCK)[0],
    );

    if (unlessPosition < 0) {
        return {
            unless: [],
            block: [],
        };
    }

    return {
        unless: nodes.slice(0, unlessPosition).map(n => n.value),
        block: nodes.slice(unlessPosition).map(n => n.value),
    };
}

/**
 * Transforms a blacklist node set into the GQL JSON format.
 * 
 * @export
 * @param {BlacklistNode[][]} nodeSets 
 * @returns {BlacklistPayload} 
 */
export function parseNodes(nodeSets: BlacklistNode[][]): BlacklistPayload {
    const payload: BlacklistPayload = {
        combined: [],
        unless: [],
        block: [],
    };

    if (nodeSets === undefined) {
        return payload;
    }

    for (const set of nodeSets) {
        if (_.first(set)!.directive === BlacklistDirective.UNLESS) {
            payload.unless!.push(parseUnlessSet(set));
        } else if (set.length > 1) {
            payload.combined!.push(set.map(n => n.value));
        } else {
            payload.block!.push(set[0].value);
        }
    }

    return payload;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/nodeParser.ts